import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { FeatureTarget } from '@frontend/functionality/types';
import React from 'react';
import useFeatureTargetSelect from './feature-target-select.controller';
export interface FeatureTargetSelectProps extends Omit<SelectInputV2Props<FeatureTarget>, 'options'> {
    subset?: string[];
}

export const FeatureTargetSelect = (props: FeatureTargetSelectProps) => {
    const viewProps = useFeatureTargetSelect(props);

    return (
        <SelectInputV2
            {...props}
            options={viewProps.options}
        />
    );
};

export default FeatureTargetSelect;
